"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const locale_1 = require("@mui/material/locale");
const styles_1 = require("@mui/material/styles");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
const locales_1 = require("@mui/x-date-pickers/locales");
const CoreContext_1 = require("../_InternalComponents/CoreContext");
const en_US_1 = tslib_1.__importDefault(require("../_InternalUtils/date-fns/locale/en-US"));
const nb_NO_1 = tslib_1.__importDefault(require("../_InternalUtils/date-fns/locale/nb-NO"));
const styles_2 = require("../styles");
const getThemeObject = (theme, locale, themeOpts = {}) => {
    const localeObjects = getLocaleObjects(locale);
    switch (theme) {
        case "nfcert":
            return (0, styles_2.createNfcertTheme)(themeOpts, ...localeObjects);
        case "mnemonic":
        default:
            return (0, styles_2.createDefaultTheme)(themeOpts, ...localeObjects);
    }
};
const getLocaleObjects = (locale) => {
    switch (locale) {
        case "nb-NO":
            return [locale_1.nbNO, locales_1.nbNO];
        case "en-US":
        default:
            return [locale_1.enUS, locales_1.enUS];
    }
};
const getAdapterLocaleByLocaleString = (locale) => {
    switch (locale) {
        case "nb-NO":
            return nb_NO_1.default;
        case "en-US":
        default:
            return en_US_1.default;
    }
};
/**
 *
 * A provider that configures material related providers based on a theme and locale string.
 * The provider will configure the following providers:
 * - ThemeProvider
 * - LocalizationProvider
 *
 * @param props
 * @returns
 */
const CoreMui5Provider = (props) => {
    const { theme, locale, themeOptions, domain, children } = props;
    const themeObject = (0, react_1.useMemo)(() => getThemeObject(theme, locale, themeOptions), [theme, locale, themeOptions]);
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: themeObject },
        react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.AdapterDateFns, adapterLocale: getAdapterLocaleByLocaleString(locale) },
            react_1.default.createElement(CoreContext_1.CoreContextProvider, { domain: domain }, children))));
};
exports.default = CoreMui5Provider;
